'use strict';
(() => {
  function selectProductMatches(items,query,limit=6){
    const normalize=value=>String(value||'').normalize('NFKD').replace(/\p{M}/gu,'').toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu,' ').trim();
    const phrase=normalize(query),terms=phrase.split(/\s+/).filter(Boolean),compact=phrase.replace(/\s/g,'');
    const matches=items.filter(item=>{
      const title=normalize(item.dataset.searchTitle),words=title.split(/\s+/);
      return compact&&(title.replace(/\s/g,'').includes(compact)||terms.every(term=>words.some(word=>word.startsWith(term))));
    });
    return (matches.length?matches:items).slice(0,limit);
  }
  if(customElements.get('idolnest-search'))return;
  class IdolnestSearch extends HTMLElement {
    connectedCallback(){
      if(this.events)return;
      this.dialog=this.querySelector('[data-in-search-dialog]');
      this.input=this.querySelector('[data-in-search-input]');
      this.results=this.querySelector('[data-in-search-results]');
      this.status=this.querySelector('[data-in-search-status]');
      this.discovery=this.querySelector('[data-in-search-discovery]');
      this.all=this.querySelector('[data-in-search-all]');
      this.allLabel=this.all?.querySelector('span')||this.all;
      this.clear=this.querySelector('[data-in-search-clear]');
      if(!this.dialog||!this.input||!this.results||!this.status||!this.all)return;
      try{this.copy=JSON.parse(this.querySelector('[data-in-search-copy]')?.textContent||'{}');}catch{this.copy={};}
      this.events=new AbortController();
      this.version=0;
      this.query='';
      const options={signal:this.events.signal};
      this.input.addEventListener('input',()=>{if(!this.composing)this.schedule();},options);
      this.input.addEventListener('compositionstart',()=>{this.composing=true;this.cancelPending();},options);
      this.input.addEventListener('compositionend',()=>{this.composing=false;this.schedule();},options);
      this.input.addEventListener('keydown',event=>{
        if(event.key==='ArrowDown'&&!this.composing&&!this.results.hidden){const first=this.results.querySelector('[data-in-search-result]');if(first){event.preventDefault();first.focus();}}
      },options);
      this.querySelector('form').addEventListener('submit',event=>{
        if(this.composing){event.preventDefault();return;}
        this.input.value=this.input.value.trim();
        if(!this.input.value){event.preventDefault();this.input.focus();this.schedule();}
      },options);
      this.addEventListener('click',event=>{
        const close=event.target.closest('[data-in-search-close]');
        if(close){this.dialog.close();return;}
        if(event.target.closest('[data-in-search-clear]')){this.input.value='';this.schedule();this.input.focus();return;}
        const term=event.target.closest('[data-in-search-term]');
        if(term){this.input.value=term.dataset.inSearchTerm||term.textContent.trim();this.schedule(true);this.input.focus({preventScroll:true});}
      },options);
      this.dialog.addEventListener('click',event=>{
        if(event.target!==this.dialog)return;
        const r=this.dialog.getBoundingClientRect();
        if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();
      },options);
      this.dialog.addEventListener('close',()=>this.afterClose(),options);
    }
    disconnectedCallback(){
      const wasOpen=this.dialog?.open;
      this.cancelPending();
      if(wasOpen){this.dialog.close();this.restoreScroll();}
      this.events?.abort();
      this.events=null;
    }
    open(){
      if(!this.dialog||this.dialog.open)return;
      this.opener=document.activeElement;
      this.previousOverflow=document.body.style.overflow;
      this.syncArtistShortcuts();
      this.dialog.showModal();
      document.body.style.overflow='hidden';
      this.input.focus({preventScroll:true});
      this.schedule(true);
    }
    restoreScroll(){
      if(this.previousOverflow!==undefined){if(!document.querySelector('dialog[open]'))document.body.style.overflow=this.previousOverflow;this.previousOverflow=undefined;}
    }
    afterClose(){
      if(this.dialog.open)return;
      this.cancelPending();
      this.composing=false;
      this.restoreScroll();
      if(this.opener?.isConnected&&!document.querySelector('dialog[open]'))this.opener.focus({preventScroll:true});
    }
    cancelPending(){
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller=null;
      this.version=(this.version||0)+1;
      this.results?.setAttribute('aria-busy','false');
    }
    syncArtistShortcuts(){
      if(this.dataset.autoArtists!=='true')return;
      const names=[...new Set(Array.from(document.querySelectorAll('.artist-card[data-in-shared-artist] .in-artist-name')).map(a=>a.textContent.trim()).filter(Boolean))].slice(0,24);
      const holder=this.querySelector('[data-in-search-shortcuts]');
      if(!holder||!names.length)return;
      const fragment=document.createDocumentFragment();
      names.forEach(name=>{const button=document.createElement('button');button.type='button';button.className='in-search-chip';button.dataset.inSearchTerm=name;button.textContent=name;fragment.append(button);});
      holder.replaceChildren(fragment);
    }
    fullSearchUrl(query){
      const url=new URL(this.dataset.searchUrl,location.origin);
      if(url.origin!==location.origin)throw new Error('Search origin mismatch');
      url.searchParams.set('type','product');
      url.searchParams.set('options[prefix]','last');
      url.searchParams.set('q',query);
      return url.pathname+url.search;
    }
    schedule(immediate=false){
      this.cancelPending();
      const query=this.input.value.trim();
      this.query=query;
      const revision=this.version;
      this.clear.hidden=!this.input.value;
      if(this.discovery)this.discovery.hidden=!!query;
      this.results.replaceChildren();
      this.results.hidden=true;
      this.all.hidden=!query;
      if(query){
        this.all.href=this.fullSearchUrl(query);
        this.allLabel.textContent=String(this.copy.all_results||'').replaceAll('{query}',()=>query);
      }
      if(!query){this.status.textContent='';return;}
      if(query.length<Math.max(1,Number(this.dataset.minChars)||2)){this.status.textContent=this.copy.short||'';return;}
      this.status.textContent=this.copy.loading||'';
      this.results.setAttribute('aria-busy','true');
      this.timer=setTimeout(()=>this.load(query,revision),immediate?0:220);
    }
    isCurrent(query,revision,controller){
      return this.isConnected&&this.dialog.open&&this.version===revision&&this.query===query&&this.input.value.trim()===query&&!controller.signal.aborted;
    }
    async load(query,revision){
      const controller=new AbortController();
      this.controller=controller;
      const timeout=setTimeout(()=>{
        if(!this.isCurrent(query,revision,controller))return;
        this.results.replaceChildren();
        this.results.hidden=true;
        this.results.setAttribute('aria-busy','false');
        this.status.textContent=this.copy.error||'';
        controller.abort();
      },8000);
      try{
        const url=new URL(this.dataset.suggestUrl,location.origin);
        if(url.origin!==location.origin)throw new Error('Search origin mismatch');
        url.searchParams.set('q',query);
        url.searchParams.set('resources[type]','product');
        url.searchParams.set('resources[limit]','10');
        url.searchParams.set('resources[options][unavailable_products]','last');
        url.searchParams.set('section_id','idolnest-search-results');
        const response=await fetch(url,{credentials:'same-origin',headers:{Accept:'text/html'},signal:controller.signal});
        if(!response.ok)throw new Error('Search preview unavailable');
        const html=await response.text();
        if(!this.isCurrent(query,revision,controller))return;
        const content=new DOMParser().parseFromString(html,'text/html').querySelector('[data-in-search-result-content]');
        if(!content)throw new Error('Search preview missing');
        const items=[...content.querySelectorAll('[data-in-search-item]')];
        if(items.length){
          const selected=selectProductMatches(items,query),list=content.querySelector('.in-search-results-list');
          list?.replaceChildren(...selected);
          content.dataset.resultCount=String(selected.length);
        }
        const count=Math.max(0,Number(content.dataset.resultCount)||0);
        this.results.replaceChildren(document.importNode(content,true));
        this.results.hidden=false;
        this.status.textContent=count?String(this.copy.summary||'').replaceAll('{count}',()=>String(count)):(this.copy.empty_status||'');
      }catch(error){
        if(!this.isCurrent(query,revision,controller))return;
        this.results.replaceChildren();
        this.results.hidden=true;
        this.status.textContent=this.copy.error||'';
      }finally{
        clearTimeout(timeout);
        if(this.version===revision){this.results.setAttribute('aria-busy','false');this.controller=null;}
      }
    }
  }
  customElements.define('idolnest-search',IdolnestSearch);
})();
